import { useContext, useEffect } from "react";

import { ChartTimeline, Threshold, TimeseriesEvent } from "../reducer";
import { TimelineContext } from "../timeline-chart";

export interface TimelineChartChartProps {
  id: string; // Unique identifier for the chart
  title: string;
  scale: "interval" | "ratio";
  color: string;
  unit: string /* Must be in yAxes array */;
  data: TimeseriesEvent[];
  isLoading: boolean;
  thresholds: Threshold[];
}

export function TimelineChartChart(props: TimelineChartChartProps) {
  const { dispatch, currentState } = useContext(TimelineContext);

  useEffect(() => {
    return () => {
      dispatch({ type: "REMOVE_CHART", id: props.id });
      // Cleanup function to remove the chart when the component is unmounted
    };
  }, [dispatch, props.id]);

  const chartTimeseries: ChartTimeline = {
    id: props.id,
    title: props.title,
    scale: props.scale,
    color: props.color,
    unit: props.unit,
    data: props.data,
    isLoading: props.isLoading,
    thresholds: props.thresholds,
  };

  const currentChart = currentState.charts.filter((chart) => chart.id === props.id);

  if (currentChart.length > 0) {
    // Check if anything has changed
    const existingChart = currentChart[0];
    if (
      existingChart.title === chartTimeseries.title &&
      existingChart.scale === chartTimeseries.scale &&
      existingChart.color === chartTimeseries.color &&
      existingChart.unit === chartTimeseries.unit &&
      existingChart.isLoading === chartTimeseries.isLoading &&
      existingChart.data.length === chartTimeseries.data.length &&
      existingChart.data.every(
        (d, i) =>
          d.time.getTime() === chartTimeseries.data[i].time.getTime() &&
          d.value === chartTimeseries.data[i].value
      ) &&
      existingChart.thresholds.length === chartTimeseries.thresholds.length &&
      existingChart.thresholds.every(
        (t, i) =>
          t.key === chartTimeseries.thresholds[i].key &&
          t.name === chartTimeseries.thresholds[i].name &&
          t.value === chartTimeseries.thresholds[i].value &&
          t.timeseries.join(",") === chartTimeseries.thresholds[i].timeseries.join(",") &&
          t.unit === chartTimeseries.thresholds[i].unit
      )
    ) {
      // No changes, do not dispatch
      return null;
    }
  }

  dispatch({
    type: "ADD_CHART",
    chart: chartTimeseries,
  });

  return null;
}
